(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["im-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('im-delivery-estimate')) {
    class ImDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const out = this.querySelector('[data-de-range]');
        if (!out || isNaN(min) || isNaN(max)) return;
        const locale = document.documentElement.lang || 'en-US';
        let fmt;
        try {
          fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' });
        } catch (e) {
          fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        }
        out.textContent = fmt.format(this.addBusinessDays(min)) + ' \u2013 ' + fmt.format(this.addBusinessDays(max));
      }
      addBusinessDays(n) {
        const d = new Date();
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          const day = d.getDay();
          if (day !== 0 && day !== 6) added += 1;
        }
        return d;
      }
    }
    customElements.define('im-delivery-estimate', ImDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
